import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { Router } from "@remix-run/router";

const RootLayout = React.lazy(
  async () => await import("@/components/RootLayout")
);
const HomePage = React.lazy(async () => await import("@/pages/HomePage"));
const EventsLog = React.lazy(async () => await import("@/pages/EventsLog"));
const Reports = React.lazy(async () => await import("@/pages/Reports"));
const Settings = React.lazy(async () => await import("@/pages/Settings"));
const NotFound = React.lazy(async () => await import("@/pages/NotFound"));
const Login = React.lazy(async () => await import("@/pages/Login"));
export const router = (isAuth: boolean): Router => {
  return createBrowserRouter(
    isAuth
      ? [
          {
            path: "/",
            element: <RootLayout />,
            children: [
              {
                index: true,
                element: <HomePage />,
              },
              {
                path: "/events-log",
                element: <EventsLog />,
              },
              {
                path: "/reports",
                element: <Reports />,
              },
              {
                path: "/settings",
                element: <Settings />,
              },
            ],
          },
          {
            path: "*",
            element: <NotFound />,
          },
        ]
      : [
          {
            path: "/login",
            index: true,
            element: <Login />,
          },
          { path: "*", element: <Navigate to="/login" /> },
        ]
  );
};
